import { TTnaUpdateActions } from './tna-updates.actions';
import { TNA_UPDATES_ITEMS_PER_PAGE_LIST } from './tna-updates.facade';
import { TTnaUpdateState, TTnaUpdateActionType } from './tna-updates.models';

export const initialState: TTnaUpdateState = {
  tnaOrderStepList: null,
  tnaOrderStep: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: TNA_UPDATES_ITEMS_PER_PAGE_LIST[0],
  },
};

export function tnaStepsReducer(state = initialState, action: TTnaUpdateActions): TTnaUpdateState {
  switch (action.type) {
    case TTnaUpdateActionType.GetTnaOrderStepListSuccess:
      return {
        ...state,
        tnaOrderStepList: {
          tnaStepList: action.tnaList,
          fetchReason: action.fetchReason,
        },
      };
    case TTnaUpdateActionType.GetTnaOrderStepSuccess:
      return {
        ...state,
        tnaOrderStep: {
          tnaStep: action.tnaStep,
          tosId: action.tosId,
        },
      };
    case TTnaUpdateActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    default:
      return state;
  }
}
